<div class="component">
  <div class="row row-space">
    <div class="col-sm-11">
      <div class="back-div">
        <span><i class="fa fa-angle-left" aria-hidden="true"></i></span>
        <span class="back-label" (click)="onClickBack()">{{ copyBack }}</span>
      </div>
    </div>
  </div>

  <div class="border-div static-space col-sm-12"></div>

  <div class="mobile-pad">
    <label class="label-xl">{{ copyCOI }}</label>

    <div *ngIf="totalOutages > 0">
      <div class="row row-space">
        <div *ngFor="let info of currentOutageInfo" class="col-sm-11 row-cell">
          <label class="label-medium">{{ info.label }}</label>
          <p class="p-value mobile-float">{{ info.value }}</p>
        </div>
      </div>

      <p class="static-text static-space">{{ copyStatic }}</p>

      <label class="label-large">{{ copyCPR }}</label>

      <div *ngIf="projectedRestCust.length > 0" class="row row-space">
        <div *ngFor="let cust of projectedRestCust; let i = index" class="col-sm-8 row-cell">
          <label *ngIf="cust.key !== 'RESTPROJECTEDEXTENDED'"
            class="label-medium">{{ cust.label | date: 'MM/d/yyyy' }}</label>
          <label *ngIf="cust.key === 'RESTPROJECTEDEXTENDED'" class="label-medium">{{ cust.label | date: 'MM/d/yyyy' }}
            TO
            {{ dateExtended | date: 'MM/d/yyyy' }}</label>
          <p class="p-value">{{ cust.value }}</p>
        </div>
      </div>

      <p *ngIf="projectedRestCust.length === 0" class="static-text row-space">{{ copyNoCPR }}</p>
    </div>

    <p *ngIf="totalOutages === 0" class="static-text row-space">{{ copyNoCOI }}</p>

    <label class="label-large">{{ copyEI }}</label>

    <div *ngIf="electricInfra.length > 0">
      <div class="row row-space">
        <div *ngFor="let infra of electricInfra" class="col-sm-8 row-cell">
          <label class="label-small">{{ infra.label }}</label>
          <p class="p-value">{{ infra.value }}</p>
        </div>
      </div>
    </div>

    <p *ngIf="electricInfra.length === 0" class="static-text row-space">{{ copyNoEI }}</p>

    <app-button-common classType="text" class="static-space" (click)="onClickURP()">
      <span class="urp">{{ copyURP }}</span>
    </app-button-common>
  </div>
</div>